export default "__VITE_ASSET__DRj7Q0l1__"